// Module
var code = "<react-component name=\"SignedWaiversList\"></react-component>\n";
// Exports
module.exports = code;